import { CustomModalLayout, Divider, Heading, Text } from '@wix/design-system';
import { DataHooks } from '../../../../constants/dataHooks';
import { PreSteps } from './PreSteps';
import css from '../../TemplatePage.scss';
import { TerminalExample } from './TerminalExample/TerminalExample';
import React from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { useSingleTemplateData } from '../../../../hooks/useSingleTemplateData';
import { useTemplatesPageBi } from '../../../../hooks/useTemplatesPageBi';

export const CLIModalLayout = ({ closeModal }) => {
  const { t } = useTranslation();
  const { template } = useSingleTemplateData();
  const { reportCloseCliModalClick } = useTemplatesPageBi();

  const onCloseClick = () => {
    reportCloseCliModalClick(template.id);
    closeModal();
  };

  return (
    <CustomModalLayout
      dataHook={DataHooks.CLIModalLayout}
      width={600}
      showHeaderDivider
      showFooterDivider
      title={t('app.template-page.modal.cli.title')}
      primaryButtonText={t('app.template-page.modal.primary-button')}
      onCloseButtonClick={onCloseClick}
      primaryButtonOnClick={onCloseClick}
    >
      <Heading size="small">
        {t('app.template-page.modal.cli.steps-title')}
      </Heading>
      <Text size="small" weight="thin">
        {t('app.template-page.modal.cli.steps-subtitle')}
      </Text>
      <PreSteps />
      <div className={css.modalDivider}>
        <Divider />
      </div>
      <Heading size="small">
        {t('app.template-page.modal.cli.select-and-copy-title')}
      </Heading>
      <Text size="small" weight="thin">
        {t('app.template-page.modal.cli.select-and-copy-subtitle')}
      </Text>
      <TerminalExample />
    </CustomModalLayout>
  );
};
